(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function(){var h=document.querySelector('header.site-header');var r=document.querySelector(':root');h&&r&&r.style.setProperty('--header-height',h.offsetHeight+'px');})();

  } catch(e) { console.error(e); }
})();
})();
